import angular from 'angular';

import componentsModule from './components/components';

const Internal = angular.module('control-room.internal', [componentsModule.name]);

export default Internal;
